import Heading from "../../../components/heading/heading.component";
import PrivacyContent from "./PrivacyContent";
import { PrivacyNoticeContainer,HeadingStyled, LinkStyled } from "./PrivacyNotice.styles";

const PrivacyNotice = () => {
  return (
    <PrivacyNoticeContainer className="App login_page">
      <Heading previusPage={'Privacy Policy'} />
      <PrivacyContent />
    </PrivacyNoticeContainer>
  );
};

export default PrivacyNotice;